var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_icon02",
    transform: "translate(1.258 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_58",
    "data-name": "\\uD0C0\\uC6D0 58",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(14.742 15)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_266",
    "data-name": "\\uADF8\\uB8F9 266",
    transform: "translate(33.673 21.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_59",
    "data-name": "\\uD0C0\\uC6D0 59",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(8.068)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_90",
    "data-name": "\\uC120 90",
    x2: 8.07,
    transform: "translate(0 3.598)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_267",
    "data-name": "\\uADF8\\uB8F9 267",
    transform: "translate(30.958 31.155)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_60",
    "data-name": "\\uD0C0\\uC6D0 60",
    cx: 3.53,
    cy: 3.53,
    r: 3.53,
    transform: "translate(4.672 4.672)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_91",
    "data-name": "\\uC120 91",
    x2: 5.706,
    y2: 5.706,
    transform: "translate(0)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_268",
    "data-name": "\\uADF8\\uB8F9 268",
    transform: "translate(21 33.871)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_61",
    "data-name": "\\uD0C0\\uC6D0 61",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-0.258 8.129)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_92",
    "data-name": "\\uC120 92",
    y2: 8.07,
    transform: "translate(3.401 0)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_269",
    "data-name": "\\uADF8\\uB8F9 269",
    transform: "translate(6.113 31.155)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_62",
    "data-name": "\\uD0C0\\uC6D0 62",
    cx: 3.53,
    cy: 3.53,
    r: 3.53,
    transform: "translate(0 4.672)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_93",
    "data-name": "\\uC120 93",
    x1: 5.706,
    y2: 5.706,
    transform: "translate(6.026)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_270",
    "data-name": "\\uADF8\\uB8F9 270",
    transform: "translate(0 21.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_63",
    "data-name": "\\uD0C0\\uC6D0 63",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-0.258)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_94",
    "data-name": "\\uC120 94",
    x1: 8.07,
    transform: "translate(7.06 3.598)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_271",
    "data-name": "\\uADF8\\uB8F9 271",
    transform: "translate(6.113 6.31)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_64",
    "data-name": "\\uD0C0\\uC6D0 64",
    cx: 3.53,
    cy: 3.53,
    r: 3.53,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_95",
    "data-name": "\\uC120 95",
    x1: 5.706,
    y1: 5.706,
    transform: "translate(6.026 6.026)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_272",
    "data-name": "\\uADF8\\uB8F9 272",
    transform: "translate(21)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_65",
    "data-name": "\\uD0C0\\uC6D0 65",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-0.258)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_96",
    "data-name": "\\uC120 96",
    y1: 8.07,
    transform: "translate(3.401 7.257)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_273",
    "data-name": "\\uADF8\\uB8F9 273",
    transform: "translate(30.958 6.31)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_66",
    "data-name": "\\uD0C0\\uC6D0 66",
    cx: 3.53,
    cy: 3.53,
    r: 3.53,
    transform: "translate(4.672 0)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_97",
    "data-name": "\\uC120 97",
    y1: 5.706,
    x2: 5.706,
    transform: "translate(0 6.026)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon02);
export default __webpack_public_path__ + "static/media/data_icon02.8c629c284b66323eab343a057605e145.svg";
export { ForwardRef as ReactComponent };